import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allProducts } from 'app/mocks/data/catalogue/products'
import { allManagers } from 'app/mocks/data/park/managers'

import { api } from 'app/utils/constants'

import { PriceLinesRequest } from 'app/types/catalogue/priceTable/priceLine'

export const getPriceTable = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.priceTables.LINES}`,
    ({ params }) => {
        const { id } = params

        const managerFound = allManagers.find(
            (manager) => manager.id.toString() === id,
        )

        // Not found
        if (!managerFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        const products = allProducts.filter(
            (product) => product.client.id === managerFound.id,
        )

        const priceTable = []

        for (const product of products) {
            priceTable.push({
                ...product,
                product,
            })
        }

        return HttpResponse.json<PriceLinesRequest>({
            results: priceTable,
        })
    },
)
